import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ErrorDisplayService {
  private readonly _showErrorMessage = signal(false);
  readonly showErrorMessage = this._showErrorMessage.asReadonly();

  private readonly _errorMessageText = signal('Something went wrong');
  readonly errorMessageText = this._errorMessageText.asReadonly();

  timeout = 5000;

  showError(errorMessage: string) {
    this._errorMessageText.set(errorMessage);
    this._showErrorMessage.set(true);

    setTimeout(() => {
      this._showErrorMessage.set(false);
    }, this.timeout);
  }
}
